// extracted by mini-css-extract-plugin
export default {"inlineAdWrapper":"NR-z","inlineTitle":"OR-z","sponsoredAdsWrapper":"PR-z","marketplaceRecosWrapper":"QR-z"};